import React, { useState } from "react";

const OnboardingScreen = ({ onFinish }) => {
  const [step, setStep] = useState(0);

  const steps = [
    {
      title: "歡迎使用 Flex Editor",
      desc: "專為 LINE 行銷設計的圖文選單編輯器，免寫程式，輕鬆打造高質感的 Flex Message。",
      image: "/img0.jpg",
      color: "#3b82f6" // 經典藍：專業、歡迎
    },
    {
      title: "步驟 1：取得 LINE API 憑證",
      desc: "前往 LINE Developers 網站，取得專屬的 Access Token 與 User ID，為您的官方帳號開啟進階功能。",
      image: "/img1.jpg",
      color: "#10b981" // 翡翠綠：呼應 LINE 品牌色，代表開始
    },
    {
      title: "步驟 2：註冊並綁定帳號",
      desc: "免費註冊並登入系統，貼上您的 Token 與 User ID 進行綁定，即可開始建立您的專屬圖文選單。",
      image: "/img2.jpg",
      color: "#f59e0b" // 活力橘：引導註冊行動
    },
    {
      title: "步驟 3：管理頁面與素材",
      desc: "在左側面板輕鬆管理頁面。您可以自由新增、拖曳排序，並上傳豐富的圖片素材，打造完美的輪播訊息。",
      image: "/img3.jpg",
      color: "#ec4899" // 桃紅色：代表創意與豐富內容
    },
    {
      title: "步驟 4：選擇完美排版",
      desc: "提供多款實用排版樣式。無論是單一焦點或多重按鈕，一鍵套用最適合的版型，瞬間抓住客戶目光。",
      image: "/img4.jpg",
      color: "#8b5cf6" // 質感紫：代表設計與排版
    },
    {
      title: "步驟 5：視覺化即時編輯",
      desc: "直覺的點擊操作！點選畫布上的文字或按鈕，即可在右側屬性欄即時修改顏色、文字大小與點擊連結。",
      image: "/img5.jpg",
      color: "#06b6d4" // 亮青色：代表科技感與精準編輯
    },
    {
      title: "步驟 6：測試與一鍵發送",
      desc: "發送前可先推送「測試訊息」至個人 LINE 確認效果。一切完美後，一鍵「全體發送」輕鬆觸及所有好友。",
      image: "/img6.jpg",
      color: "#14b8a6" // 藍綠色：代表安全、成功發送
    },
    {
      title: "問題解決了嗎？",
      desc: "若有任何疑問，隨時點擊右上角的「新手導覽」按鈕，查看完整教學與常見問題。祝您行銷順利！",
      image: "/img7.jpg",
      color: "#f43f5e" // 玫瑰紅：代表熱情與客服支援
    }
  ];

  const handleNext = () => {
    if (step < steps.length - 1) {
      setStep(step + 1);
    } else {
      onFinish();
    }
  };

  return (
    <div
      style={{
        width: "100vw",
        height: "100vh",
        background: "var(--bg-main)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        position: "relative",
        overflow: "hidden"
      }}
    >
      {/* 背景動態裝飾 */}
      <div style={{ position: "absolute", top: -100, right: -100, width: 500, height: 500, background: steps[step].color, filter: "blur(200px)", opacity: 0.15, transition: "background 0.5s" }}></div>
      <div style={{ position: "absolute", bottom: -100, left: -100, width: 500, height: 500, background: steps[step].color, filter: "blur(200px)", opacity: 0.15, transition: "background 0.5s" }}></div>

      <div
        style={{
          width: 1200, 
          maxWidth: "95vw",
          height: "90vh", 
          background: "var(--bg-panel)",
          border: "1px solid var(--border-color)",
          borderRadius: 24,
          padding: "20px 40px", 
          textAlign: "center",
          boxShadow: "0 20px 60px rgba(0,0,0,0.6)",
          zIndex: 10,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          overflow: "hidden" 
        }}
      >
        {/* 圖片顯示區塊 */}
        <div 
          style={{ 
            width: "100%", 
            flex: 1, 
            minHeight: 0, 
            marginBottom: 12, 
            display: "flex", 
            alignItems: "center", 
            justifyContent: "center",
            overflow: "hidden",
            borderRadius: 16,
            background: "#111" 
          }}
        >
          <img 
            key={step}
            src={steps[step].image} 
            alt={steps[step].title}
            style={{ 
              maxWidth: "100%", 
              maxHeight: "100%", 
              objectFit: "contain",
              animation: "fadeIn 0.4s ease-out" 
            }} 
            onError={(e) => {
              e.target.style.display = "none";
              e.target.parentNode.innerHTML = `<span style="color:#666;font-size:14px">圖片讀取失敗<br/>請確認 public 資料夾內是否有該檔案</span>`;
            }}
          />
        </div>
        
        {/* 下方文字與按鈕區塊 */}
        <div style={{ flexShrink: 0, width: "100%", display: "flex", flexDirection: "column", alignItems: "center" }}>
          
          <h2 style={{ color: "#fff", marginBottom: 4, fontSize: 22, fontWeight: "bold", letterSpacing: "1px" }}>
            {steps[step].title}
          </h2>
          
          <p style={{ color: "#aaa", lineHeight: 1.4, marginBottom: 12, minHeight: 38, maxWidth: "70%", fontSize: 13 }}>
            {steps[step].desc}
          </p>

          <div style={{ display: "flex", gap: 8, marginBottom: 12 }}>
            {steps.map((_, idx) => (
              <div
                key={idx}
                style={{
                  width: idx === step ? 24 : 8,
                  height: 8,
                  borderRadius: 4,
                  background: idx === step ? steps[step].color : "#444",
                  transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
                  cursor: "pointer"
                }}
                onClick={() => setStep(idx)}
              />
            ))}
          </div>

          <button
            onClick={handleNext}
            style={{
              background: steps[step].color,
              color: "#fff",
              border: "none",
              borderRadius: 50,
              padding: "10px 40px",
              fontSize: 15,
              fontWeight: "bold",
              cursor: "pointer",
              boxShadow: `0 8px 20px ${steps[step].color}55`,
              transition: "all 0.2s transform"
            }}
            onMouseOver={(e) => e.target.style.transform = "scale(1.03)"}
            onMouseOut={(e) => e.target.style.transform = "scale(1)"}
          >
            {step === steps.length - 1 ? "開始使用" : "下一步 →"}
          </button>

          {step < steps.length - 1 ? (
            <button 
              onClick={onFinish}
              style={{ marginTop: 8, background: "none", border: "none", color: "#777", fontSize: 12, cursor: "pointer", textDecoration: "underline", transition: "color 0.2s" }}
              onMouseOver={(e) => e.target.style.color = "#aaa"}
              onMouseOut={(e) => e.target.style.color = "#777"}
            >
              跳過導覽
            </button>
          ) : (
            <div style={{ height: 24 }}></div> 
          )}
        </div>
      </div>
      
      <style>{`
        @keyframes fadeIn { 
          from { opacity: 0; transform: translateY(10px); } 
          to { opacity: 1; transform: translateY(0); } 
        }
      `}</style>
    </div>
  );
};

export default OnboardingScreen;